import { all, call, getContext, put, takeLatest } from 'redux-saga/effects';
import queryString from 'query-string';
import { Logger } from 'utils/Logger';
import { requestActivitiesFailure, requestActivitiesSuccess } from './actions';
import { activities } from './types';

const logger = new Logger('Saga:Dashboard:Activities');

export function* getActivities(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.get,
      `${routerService.generate('api.activities.all')}?${queryString.stringify(action.queryArgs)}`,
    );

    logger.info('Got new activities');
    if (action.promise) action.promise.resolve(response.data);
    yield put(requestActivitiesSuccess(response.data));
  } catch (error) {
    logger.error(error);
    if (action.promise) action.promise.reject(error);
    yield put(requestActivitiesFailure(error));
  }
}

export default function* activitiesSaga() {
  return yield all([takeLatest(activities.request, getActivities)]);
}
